<template lang="pug">
	.language-select-box(:class="{compact}")
		dx-select-box(
			v-bind="$attrs"
			v-on="$listeners"
			styling-mode="filled"
			:items="items && items.length ? items : (compact ? $locale.state.availableLocales : getAllLocales())"
			:height="36"
			:width="compact ? '36px' : '100%'"
			:drop-down-options="dropDownOptions"
			:show-drop-down-button="!compact"
			:fieldTemplate="'fieldTemplate'",
			item-template="item"
		)
			template(#item="{data}")
				slot(name="item" :data="data")
					span(:title="`${data.label} (${data.code})`") {{data.label}}
			template(#fieldTemplate="{data}")
				.content.full-width.full-height
					.flex-row.full-height.full-width.align-center.center
						span {{(compact ? displayValue : selectedValue) || 'EN'}}
					dx-text-box(v-show="!compact" :class="{ hidden: compact }" v-bind="$attrs")
</template>

<script>
	import DxSelectBox from 'devextreme-vue/select-box';
	import DxTextBox from 'devextreme-vue/text-box';
	import VueTypes from "vue-types";
	import _ from 'lodash';

	const langmap = require("langmap");

	export default {
		name: "LanguageSelectBox",
		components: {
			DxSelectBox, DxTextBox
		},
		props: {
			items: VueTypes.array.def([]),
			value: VueTypes.any.def(null),
			compact: VueTypes.bool.def(false)
		},
		computed: {
			locales() {
				return this.items;
			},
			displayValue() {
				return this.value && `${this.value}`.substr(0, 2).toUpperCase();
			},
			selectedValue() {
				if (_.isEmpty(this.value)) return '';
				return `${this.value.code} (${this.value.english_name})`;
			}
		},
		data() {
			return {
				dropDownOptions: {
					height: 260,
					width: this.compact ? 200 : 320
				},
			};
		},
		mounted() {
			if (__DEBUG__)
				window.languagesSelectBox = this;
		},
		methods: {
			getAllLocales() {
				const result = [];
				const currentLocales = this.$locale.state.availableLocales.map(item => item.code);
				Object.keys(langmap).forEach(code => {
					if (code.length > 2 && !currentLocales.includes(code)) {
						result.push({code, name: langmap[code].nativeName, english_name: langmap[code].englishName});
					}
				})
				return result;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.language-select-box {
		&.compact {
			margin: 0px 2px 0px 4px;
		}

		&:not(.compact) {
			width: 100%;
		}

		.dx-texteditor {
			::v-deep .dx-placeholder::before, .dx-texteditor-input {
				font-size: 14px;
				padding: 7px 12px !important;
			}

			.dx-texteditor-buttons-container {
				width: 30px;
			}
		}

		.hidden {
			position: absolute;
			display: none;
		}
	}

</style>
